import { ROUTES } from "./routes";
import AuthRoute from "./AuthRoute";
import Logout from "features/Logout";
import Delivery from "features/Delivery";
import SummaryBase from "features/Summary";
import { Route, Routes } from "react-router-dom";
import EvaluationBase from "features/Evaluation";
import LayoutBase from "features/Layout";
import ModalPromp from "components/ModalPromp";
import LoadingPage from "components/LoadingPage";
import React from "react";
import PrompConfigProvider from "./context";
import useUser from "state/User/useUser";
import { RoleNotSupport } from "features/RoleNotSupport";
import useRoleTheme from "hooks/useRoleTheme";
import useDomainValidation from "hooks/useDomainValidation";
import useClientId from "hooks/useClientId";

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: any) {
    console.error("Error boundary caught an error", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <h1>Algo salió mal. Intenta de nuevo más tarde.</h1>;
    }

    return this.props.children;
  }
}

const PrivateApp = () => {
  const { user } = useUser();
  const userRole = user?.role?.toUpperCase();
  const {clientId} = useClientId();
  const { isReady } = useRoleTheme(clientId);
  
  const { isValidRoleForDomain, allowedRole } = useDomainValidation(userRole);

  if (!isReady) {
    return <LoadingPage isLoading={isReady} />;
  }
    
  return (
    <PrompConfigProvider>
      { isValidRoleForDomain ? (
        <>
          <ModalPromp />
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={<LayoutBase />}>
                <Route
                  index
                  element={
                    <AuthRoute
                      isAuth={userRole === allowedRole}
                      redirect={ROUTES.candidate.notsupport}
                    >
                      <SummaryBase />
                    </AuthRoute>
                  }
                />
                <Route path={ROUTES.logout} element={<Logout />} />
                <Route
                  path={ROUTES.candidate.delivery}
                  element={
                    <AuthRoute
                      isAuth={userRole === allowedRole}
                      redirect={ROUTES.candidate.notsupport}
                    >
                      <Delivery />
                    </AuthRoute>
                  }
                />
                <Route
                  path="admission/:idAdmission/quizzes/:idQuizzes"
                  element={
                    <AuthRoute
                      isAuth={userRole === allowedRole}
                      redirect={ROUTES.candidate.notsupport}
                    >
                      <EvaluationBase />
                    </AuthRoute>
                  }
                />
                <Route
                  path={ROUTES.candidate.notsupport}
                  element={<RoleNotSupport />}
                />
                <Route path="*" element={<div>404 Not Found</div>} />
              </Route>
            </Routes>
          </ErrorBoundary>
        </>
      ) : (
        <RoleNotSupport />
      )}
    </PrompConfigProvider>
  );
};

export default PrivateApp;
